export function columnAvailable(columnId, availableColumns) {
  return availableColumns.map((column) => column.id).includes(columnId)
}
